export var TypeActionApp;
(function (TypeActionApp) {
    TypeActionApp["Init"] = "App > Init";
})(TypeActionApp || (TypeActionApp = {}));
export var actionAppInit = function () { return ({
    type: TypeActionApp.Init,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/app/actionApp.ts
// module id = 74
// module chunks = 3